import React, { Component } from "react";
import {
  Checkbox,
  Div,
  I,
  If,
  Input,
  Label,
  ModalNotification,
} from "../../../components";
import { Color, Http, Keys, Type, Utils } from "../../../utilities";
import CadastrarClienteMobile from "./CadastrarClienteMobile";

class LoginClienteMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usuario: this.initUsuario(),
      mensagemErro: "",
    };
  }

  initUsuario() {
    let usuarioSalvo = JSON.parse(
      localStorage.getItem(Keys.KEY_SALVAR_ACESSO_LOGIN)
    );

    if (Utils.isValueValid(usuarioSalvo)) {
      return { ...usuarioSalvo };
    } else {
      return { usuario: "", senha: "" };
    }
  }

  renderCadastrarCliente() {
    ModalNotification.renderModalLogin(
      <>
        <Label
          className="modal-title"
          style={{
            color: Color.ECOMMERCE.LARANJA,
            fontSize: 25,
            marginTop: 20,
          }}
          family="Bold"
          value="Preencha as informações para realizar o cadastro"
        />
      </>,
      <CadastrarClienteMobile responsive="8" empresa={this.props.empresa} />,
      () => {},
      "FINALIZAR CADASTRO"
    );
  }

  setEnderecoSelecionado(cliente) {
    let enderecos = Array.from(cliente.enderecos);

    if (Utils.isValueValid(enderecos)) {
      let enderecoPrincipal = enderecos.filter((end) => end.principal)[0];
      let carrinho = {
        ...this.props.carrinho,
        enderecoEntrega: enderecoPrincipal,
      };

      this.props.setEnderecoEntrega(carrinho);
    }
  }

  logarUsuario() {
    const { usuario } = this.state;

    this.setState({ mensagemErro: "" });

    Http.post("/cliente/login", usuario)
      .then(({ status, data }) => {
        if (status) {
          if (data.status) {
            //            this.setEnderecoSelecionado(data);
            localStorage.setItem(
              Keys.KEY_USUARIO_LOJA_WEB,
              JSON.stringify(data)
            );
            this.props.handlerConfirm();
          } else {
            this.setState({ mensagemErro: data.mensagem });
          }
        }
      })
      .catch((erro) => console.log(erro));
  }

  setSalvarAcessoLogin(salvar) {
    if (salvar) {
      localStorage.setItem(
        Keys.KEY_SALVAR_ACESSO_LOGIN,
        JSON.stringify({ ...this.state.usuario })
      );
    } else {
      localStorage.removeItem(Keys.KEY_SALVAR_ACESSO_LOGIN);
    }
  }

  getSalvarAcesso() {
    let acesso = JSON.parse(localStorage.getItem(Keys.KEY_SALVAR_ACESSO_LOGIN));
    return Utils.isValueValid(acesso);
  }

  render() {
    const { usuario } = this.state;
    return (
      <Div>
        <Div column margin="2">
          <Input
            placeholder="E-mail"
            handlerChange={(e) =>
              this.setState({
                usuario: { ...usuario, login: e.target.value },
              })
            }
            value={usuario.login}
            style={{
              width: "100%",
              height: 20,
              border: "none",
              fontSize: 25,
              textAlign: "center",
              backgroundColor: "transparent",
              margin: 10,
            }}
            className="border-bottom"
          />
          <Input
            type="password"
            style={{
              width: "100%",
              height: 20,
              border: "none",
              fontSize: 25,
              textAlign: "center",
              backgroundColor: "transparent",
              margin: 10,
            }}
            className="border-bottom"
            placeholder="Senha"
            handlerChange={(e) =>
              this.setState({
                usuario: { ...usuario, senha: e.target.value },
              })
            }
            value={usuario.senha}
          />
          <Div column marginTop="2">
            <Checkbox
              checked={this.getSalvarAcesso()}
              label="Salvar acesso"
              handlerChange={({ checked }) =>
                this.setSalvarAcessoLogin(checked)
              }
            />
            <Label
              value="Novo por aqui? Cadastre-se"
              style={{
                color: Color.EMPRESA.TERCIARIA,
              }}
              className="hover-link"
              handlerClick={() => {
                this.props.history.push("/cadastrarcliente");
                Utils.refreshPage();
              }}
            />
          </Div>
          <If and value1={Utils.isValueValid(this.state.mensagemErro)}>
            <Label
              value={this.state.mensagemErro}
              className="text-danger p-3 w-100 text-center"
              rounded
              family="Bold"
            />
          </If>
        </Div>

        <Div
          className="modal-footer w-100"
          marginTop="4"
          inline="between"
          style={{
            backgroundColor: "#C4C4C4",
            borderRadius: 10,
            fontSize: 25,
          }}
          pointer
          handlerClick={(e) => this.logarUsuario()}
        >
          <Label />
          <Label
            family="SemiBold"
            value="Entrar"
            style={{ color: "white" }}
            handlerClick={(e) => this.logarUsuario()}
          />
          <I
            icon={Type.ICON.ARROW_CHEV_RIGHT}
            style={{ color: "white", fontSize: 20 }}
          />
        </Div>
      </Div>
    );
  }
}

export default LoginClienteMobile;
